import $ from 'jquery';

const CLASSNAMES = {
    invisible: 'hidden',
    visible: 'visible'
};

const SELECTORS = {
    searchInput: '[data-search-in]'
};

const fixKeyboardLayout = text => {
    const en = "`qwertyuiop[]asdfghjkl;'zxcvbnm,./";
    const ru = "ёйцукенгшщзхъфывапролджэячсмитьбю.";
    const mapEnToRu = {};
    const mapRuToEn = {};

    for (let i = 0; i < en.length; i++) {
        mapEnToRu[en[i]] = ru[i];
        mapEnToRu[en[i].toUpperCase()] = ru[i].toUpperCase();
        mapRuToEn[ru[i]] = en[i];
        mapRuToEn[ru[i].toUpperCase()] = en[i].toUpperCase();
    }

    let cntEn = 0;
    let cntRu = 0;
    for (const ch of text) {
        if (/[A-Za-z]/.test(ch)) cntEn++;
        if (/[А-Яа-яЁё]/.test(ch)) cntRu++;
    }

    const map = cntEn > cntRu ? mapEnToRu : mapRuToEn;
    return Array.from(text, ch => map[ch] || ch).join('');
};

const applySearchFilter = elInput => {
    const elSearchIn = elInput.dataset.searchIn;
    if (!elSearchIn || $(elSearchIn).length === 0) {
        return;
    }

    const elSearchable = $(elSearchIn).find('> *:not(.expand)');
    const searchInput = elInput.value.trim();
    const searchPhrase = [searchInput, fixKeyboardLayout(searchInput)]
        .map(t => t.replace(/[^a-z0-9А-Я\.,ё\s-]/gi, ''))
        .join('|');

    const searchRe = new RegExp('(' + searchPhrase + ')', 'iu');

    if (searchInput) {
        ! $(elSearchIn).hasClass('expanded') &&
             $(elSearchIn).addClass('expanded').find('> .expand').remove();
        elSearchable.each(function() {
            if (searchRe.test($(this).find('label').text())) {
                $(this).addClass(CLASSNAMES.visible).removeClass(CLASSNAMES.invisible);
            } else {
                $(this).addClass(CLASSNAMES.invisible).removeClass(CLASSNAMES.visible);
            }
        });
    } else {
        elSearchable.removeClass(`${CLASSNAMES.invisible} ${CLASSNAMES.visible}`);
    }
};

/**
 * Инициализировать поиск внутри опций фильтра (data-search-in).
 */
export const initFilterOptionsSearch = () => {
    const inputs = $(SELECTORS.searchInput);
    if (inputs.length === 0) {
        return;
    }

    inputs.on('keyup change search paste', function(e) {
        setTimeout( function() { applySearchFilter(e.currentTarget) }, 0 );
    });
    inputs.each( function() {
        const elInput = $(this);
        elInput.siblings('.input-group-append').find('.btn').click( function() {
            setTimeout( function() { applySearchFilter(elInput.get(0)) }, 0 );
        });
    })
};
